




























import {
  Component,
  Vue,
} from 'vue-property-decorator';
import Drawer from '@/components/Drawer.vue';
import SubscriptionsService from '@/services/subscriptions.service';
import SigfoxPoolAddDrawer from '@/components/subscriptions/SigfoxPoolAddDrawer.vue';
import {SigfoxSubscriptionPool} from '@/types';

@Component({
  components: {
    SigfoxPoolAddDrawer,
    Drawer,
  },
})
export default class SigfoxSubscriptionPools extends Vue {
  private sigfoxPools: SigfoxSubscriptionPool[] = [];
  private sigfoxPool: any = {name: '', contractId: ''};
  private loading: boolean = true;
  private tableData: any = {
    headers: [
      {text: 'Name', value: 'name', align: 'start', filterable: true},
      {text: 'Created', value: 'createdAt'},
      {text: 'Contract ID', value: 'contractId'},
      {text: 'Type', value: 'type'},
      {text: 'Maximum number of subscriptions', value: 'maxSubscriptions'},
      {text: 'Subscriptions reserved', value: 'reservedSubscriptions'},
      {text: 'Subscriptions in use', value: 'inUseSubscriptions'},
      {text: '', value: 'actions', align: 'end'},
    ],
  };
  private showAddSigfoxSubscricptionPool: boolean = false;

  private async mounted() {
    await this.refreshSigfoxPlans();
  }

  private async refreshSigfoxPlans() {
    const sigfoxPools = await SubscriptionsService.getSigfoxSubscriptionPools();
    Vue.set(this, 'sigfoxPools', sigfoxPools);
    this.populateSigfoxPlans();
  }

  private addSigfoxSubscriptionPool() {
    this.showAddSigfoxSubscricptionPool = true;
  }

  private hideAddSigfoxSubscricptionPool() {
    this.showAddSigfoxSubscricptionPool = false;
    this.refreshSigfoxPlans();
  }

  private populateSigfoxPlans() {
    const rows: any[] = [];
    this.sigfoxPools.forEach(async (row: any) => {
      rows.push({
        id: row.id,
        name: row.name,
        createdAt: row.created_at,
        contractId: row.contract_id,
        type: row.type.code,
        maxSubscriptions: row.max_subscriptions,
        inUseSubscriptions: row.in_use_subscriptions,
        reservedSubscriptions: row.reserved_subscriptions,
      });
    });
    Vue.set(this.tableData, 'rows', rows);
    this.loading = false;

  }

}
